import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Header from './Header';
import Sidebar from './Sidebar';
import { AdminBottomTab, AreaHeadBottomTab, EngineerBottomTab, UserBottomTab } from './BottomTab';
import { useIsDesktop } from '../hooks/useMediaQuery';
import './Layout.css';

const Layout = () => {
  const { user } = useAuth();
  const isDesktop = useIsDesktop();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const role = (user?.role || '').toLowerCase().trim();
  const isAdmin = role === 'admin';
  const isEngineer = role === 'engineer';
  const isAreaHead = role === 'area_head' || role === 'area head';
  const isUser = role === 'user' || role === 'customer';

  // Debug logging for area head role detection
  useEffect(() => {
    if (role) {
      console.log('[Layout] User role:', role);
      console.log('[Layout] isAreaHead:', isAreaHead);
      console.log('[Layout] isUser:', isUser);
    }
  }, [role, isAreaHead, isUser]);

  return (
    <div className={`layout ${isDesktop ? 'layout-desktop' : 'layout-mobile'}`}>
      <Header onMenuClick={!isDesktop ? () => setSidebarOpen((o) => !o) : undefined} />
      {isDesktop && (
        <Sidebar
          isOpen={true}
          onClose={() => setSidebarOpen(false)}
          isCollapsed={sidebarCollapsed}
          onToggleCollapse={() => setSidebarCollapsed((c) => !c)}
          userRole={user?.role}
          isDesktop={true}
        />
      )}
      {!isDesktop && (
        <Sidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          isCollapsed={false}
          onToggleCollapse={() => {}}
          userRole={user?.role}
          isDesktop={false}
        />
      )}
      <main className={`main-content ${isDesktop ? 'main-with-sidebar' : ''} ${isDesktop && sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <Outlet />
      </main>
      {!isDesktop && isAdmin && <AdminBottomTab />}
      {!isDesktop && isEngineer && <EngineerBottomTab />}
      {!isDesktop && isAreaHead && <AreaHeadBottomTab />}
      {!isDesktop && isUser && <UserBottomTab />}
    </div>
  );
};

export default Layout;
